export default __webpack_public_path__ + "static/about-intro-triangle2.url-711164ea582f837097edca6aeb69c0e9.svg";